module.exports = __webpack_public_path__ + "static/media/portfolio1 (6).e80d8415.jpeg";